<template>
    <div class="image-preview tw-relative" @click="removeImage(index)">
        <template v-if="type.substring(0, 5) === 'image'">
            <img :src="preview">
            <div class="upload-progress tw-absolute tw-left-0 tw-right-0 tw-mx-auto tw-z-10 tw-rounded tw-overflow-hidden tw-bg-gray-800 tw-shadow-deep" v-if="uploading">
                <div class="tw-bg-white tw-h-full"></div>
            </div>
            <div class="finish-animation" v-if="upload_complete_animation">
                <i class="fa fa-check"></i>
            </div>
        </template>
        <template v-else>
            <p class="tw-text-center tw-p-3"><i class="far fa-file-alt tw-text-5xl tw-text-gray-600 tw-fill-current tw-mb-2"></i><br/><span class="tw-font-bold">{{ truncatedName }}</span></p>
        </template>
    </div>
</template>

<script>
    import ImageUploader from '../mixins/ImageUploader.js'

    export default {
        mixins: [ImageUploader],

        props: ['type', 'name'],
        computed: {
            truncatedName() {
                // strip html tags from the body
                let regex = /(<([^>]+)>)/ig;
                this.name = this.name.replace(regex, " ");

                // return truncated text when message is longer than 30 char, else return complete text
                return this.name.length > 15 ? this.name.slice(0, 15) + "..." : this.name;
            }
        }
    }
</script>